import { render, staticRenderFns } from "./PopupHandler.vue?vue&type=template&id=f60e5728&scoped=true&"
import script from "./PopupHandler.vue?vue&type=script&lang=js&"
export * from "./PopupHandler.vue?vue&type=script&lang=js&"
import style0 from "./PopupHandler.vue?vue&type=style&index=0&id=f60e5728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e5728",
  null
  
)

export default component.exports